export default "__VITE_ASSET__C4O3VRM1__"